import React from 'react';
import { CheckIcon } from 'lucide-react';
interface ChoiceCardProps {
  selected: boolean;
  onSelect: () => void;
  title: string;
  body?: string;
  icon?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
}
export function ChoiceCard({
  selected,
  onSelect,
  title,
  body,
  icon,
  size = 'md'
}: ChoiceCardProps) {
  const pad = size === 'sm' ? 'px-4 py-3 min-h-[52px]' : size === 'lg' ? 'p-5 min-h-[120px]' : 'px-4 py-4 min-h-[64px]';
  return <button type="button" role="radio" aria-checked={selected} onClick={onSelect} className={`relative flex w-full items-start gap-3 rounded-xl border-2 text-left transition-[border-color,background-color,transform] duration-150 ease-out active:scale-[0.98] ${pad} ${selected ? 'border-ink bg-ink text-white' : 'border-ink-200 bg-white text-ink hover:border-ink-400'}`} data-id="element-428" data-mp="fwrf7gqvujpz">
      {icon && <span className={`mt-0.5 shrink-0 ${selected ? 'text-lime' : 'text-ink-500'}`} data-id="element-429" data-mp="2mo0c16o9wsl8">{icon}</span>}
      <span className="min-w-0 flex-1" data-id="element-430" data-mp="2gl5wrf6k4hd4">
        <span className={`block font-semibold leading-snug ${size === 'lg' ? 'text-lg' : 'text-base'}`} data-id="element-431" data-mp="2gm77tjnkp3uu">{title}</span>
        {body && <span className={`mt-1 block text-sm leading-relaxed ${selected ? 'text-ink-200' : 'text-ink-500'}`} data-id="element-432" data-mp="2kly6san96qag">{body}</span>}
      </span>
      {selected && <span className="absolute right-3 top-3 flex h-5 w-5 items-center justify-center rounded-full bg-lime text-ink" aria-hidden="true" data-id="element-433" data-mp="2bl9t5h1rury3">
          <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} data-id="element-434" data-mp="1wvvk6a23ycj8" />
        </span>}
    </button>;
}